import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import {
  createContext,
  FunctionComponent,
  ReactElement,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useSearchParams } from "react-router-dom";

export const AddTeamContext = createContext(null);

type Props = {
  children: ReactElement;
};

const AddTeamProvider: FunctionComponent<Props> = ({ children }) => {
  const [queryParams, setQueryParams] = useSearchParams();

  const [paramId, setParamId] = useState("");

  const params = new URLSearchParams(queryParams);

  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.post(
        "settings/tm/case-management/groups",
        payload,
      );
      return data;
    },
    onError: (err) => {
      throw err;
    },
  });

  const {
    mutateAsync: mutateAsyncAddUser,
    data: addUserData,
    isPending: addUserIsPending,
    error: addUserError,
  } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.post(
        `settings/tm/case-management/groups/${paramId}/add-users`,
        payload,
      );
      return data;
    },
    onError: (err) => {
      throw err;
    },
  });

  useEffect(() => {
    if (params.get("view") && params.get("tid")) {
      setParamId(params.get("tid"));
    } else {
      setParamId("");
    }
  }, [params.get("view"), params.get("tid")]);

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      error,
      isPending,
      setQueryParams,
      mutateAsyncAddUser,
      addUserData,
      addUserIsPending,
      addUserError,
    }),
    [
      mutateAsync,
      data,
      error,
      isPending,
      setQueryParams,
      mutateAsyncAddUser,
      addUserData,
      addUserIsPending,
      addUserError,
    ],
  );
  return (
    <AddTeamContext.Provider value={contextValue}>
      {children}
    </AddTeamContext.Provider>
  );
};

export default AddTeamProvider;
